import {
  CardDefinition,
  CAROUSEL,
  CAROUSEL_NEXT,
  CarouselDefinition,
  CarouselNextDefinition,
  LayoutListDefinition,
  LAYOUT_LIST,
  TEXT_WRAPPER
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import { OPTIONAL_TEXT_FIELDS } from '../utils/optionalFields';

export const Cards8: Translator = sequence => {
  const { editorMode } = useEditorStore.getState();

  const carouselId = `${sequence.id}.carousel`;

  const cards: CardDefinition[] = [];
  let header: ItemOfType<'Text'> | undefined;

  const cardCount =
    sequence.items?.filter(i => i.__typename === 'Card').length || 0;
  let cardIndex = 1;

  const textList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.textlist`,
    values: {
      orientation: 'column',
      align: 'top',
      padded: false
    },
    items: [
      {
        type: TEXT_WRAPPER,
        id: 'wrapper',
        values: {
          padding: '30px 40px 0px 40px',
          margin: '10px 0',
          textAlign: 'center'
        },
        items: []
      }
    ]
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Text') {
      header = item as ItemOfType<'Text'>;
      // Learners see only the heading of the slide text.
      textList.items[0].items = TextHelper(
        {
          ...item,
          subtitle: ''
        } as ItemOfType<'Text'>,
        { optional: ['title'] }
      );
    }

    if (item.__typename === 'Card') {
      const _item = item as ItemOfType<'Card'>;

      if (editorMode) {
        _item.appear = 0;
      }

      //ENG-8698 we need to set appear to 0 for the card, because we want to show the card from the start

      cards.push(
        CardHelper(
          { ..._item, appear: 0 },
          {
            height: 'unset',
            width: '211px',
            padding: '0px',
            centerTitle: true,
            optional: OPTIONAL_TEXT_FIELDS,
            extraItems: editorMode
              ? []
              : cardIndex != cardCount
                ? [
                    {
                      id: `${item.id}.next`,
                      type: CAROUSEL_NEXT,
                      values: { carouselId },
                      items: []
                    } as CarouselNextDefinition
                  ]
                : []
          }
        )
      );
      cardIndex++;
    }

    return null;
  });

  if (editorMode) {
    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.sequenceWrapper`,
      values: {
        orientation: 'column',
        align: 'center'
      },
      items: [
        ...textList.items,
        {
          type: CAROUSEL,
          id: `${sequence.id}.carousel`,
          values: {
            variant: 'horizontal',
            cssStylesForItem: {
              placeSelf: 'baseline',
              maxHeight: '400px'
            },
            showProgressBar: false
          },
          items: cards
        } as CarouselDefinition
      ]
    } as LayoutListDefinition);
  } else {
    root.items.push({
      type: CAROUSEL,
      id: `${sequence.id}.carousel`,
      values: {
        variant: { _: 'stack', md: 'dynamic' },
        header: header
      },
      items: cards
    } as CarouselDefinition);
  }

  return root;
};
